<template>
    <div class="pagination" v-if="totalPages > 1">
        <button
            class="pager-arrow"
            :disabled="currentPage === 1"
            @click="changePage( currentPage - 1 )"
        >
            <i class="icon-arrow_left"></i>
        </button>

        <template v-for="(page, index) in paginationRange" :key="index">
            <span v-if="page === '...'" class="pager-dots">{{ page }}</span>
            <button
                v-else
                :class="{ 'pager-active': page === currentPage }"
                @click="changePage(page)"
            >
                {{ page }}
            </button>
        </template>

        <button
            class="pager-arrow"
            :disabled="currentPage === totalPages"
            @click="changePage( currentPage + 1 )"
        >
            <i class="icon-arrow_right"></i>
        </button>
    </div>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        total: { type: Number, required: true },
        pageSize: { type: Number, default: 10 },
        currentPage: { type: Number, default: 1 }
    },
    emits: ['update:currentPage'],
    computed: {
        // Общее количество страниц
        totalPages() {
            return Math.ceil( this.total / this.pageSize );
        },
        // Формируем массив кнопок с точками
        paginationRange() {

            const foo = [];
            const delta = 2;

            for( let i = 1; i <= this.totalPages; i++ ) {
                if(
                    i === 1 ||
                    i === this.totalPages ||
                    ( i >= this.currentPage - delta && i <= this.currentPage + delta )
                ) {
                    foo.push(i);
                } else if ( foo[foo.length - 1] !== '...' ) {
                    foo.push('...');
                }
            }

            return foo;
        }
    },
    methods : {
        changePage( page ) {
            if( page >= 1 && page <= this.totalPages ) {
                this.$emit( 'update:currentPage', page );
            }
        }
    }
}
</script>

<style scoped>

</style>